/* ============================================
   MAGGD — script.js
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ---------- NAVBAR + HERO PARALLAX (single rAF-throttled scroll handler) ----------
  // One passive scroll listener, batched into a single requestAnimationFrame per
  // frame, so scrolling does at most one DOM write per frame instead of many —
  // keeping the main thread free and improving tap responsiveness (INP).
  const navbar = document.getElementById('navbar');
  const heroContent = document.getElementById('heroContent');
  // Parallax is a desktop-only flourish; skip it on phones where it costs paint
  // work on weaker CPUs and adds little on a short hero.
  const parallaxOn =
    !!heroContent && window.matchMedia('(min-width: 1024px)').matches;

  if (navbar || heroContent) {
    let scrollTicking = false;

    const onScrollFrame = () => {
      const scrollY = window.scrollY;
      if (navbar) {
        navbar.classList.toggle('scrolled', scrollY > 50);
      }
      if (parallaxOn) {
        heroContent.style.opacity = Math.max(0, 1 - scrollY / 700);
        heroContent.style.transform = 'scale(' + (1 + scrollY * 0.0003) + ')';
      }
      scrollTicking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!scrollTicking) {
          scrollTicking = true;
          requestAnimationFrame(onScrollFrame);
        }
      },
      { passive: true },
    );
  }

  // ---------- MOBILE MENU ----------
  const mobileToggle = document.getElementById('mobileToggle');
  const mobileMenu = document.getElementById('mobileMenu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      mobileToggle.classList.toggle('active');
      mobileMenu.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });

    document.querySelectorAll('.mobile-menu-link').forEach(link => {
      link.addEventListener('click', () => {
        mobileToggle.classList.remove('active');
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ---------- HERO ANIMATIONS ----------
  const animateIns = document.querySelectorAll('.animate-in');
  animateIns.forEach(el => {
    const delay = parseInt(el.dataset.delay || '0');
    setTimeout(() => {
      el.classList.add('visible');
    }, 300 + delay);
  });

  // (Hero parallax is handled in the rAF-throttled scroll handler above.)

  // ---------- SCROLL REVEAL ----------
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = parseInt(entry.target.dataset.delay || '0');
        setTimeout(() => {
          entry.target.classList.add('visible');
        }, delay);
        revealObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  document.querySelectorAll('.reveal-up').forEach(el => {
    revealObserver.observe(el);
  });

  // ---------- FAQ ACCORDION ----------
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const answer = btn.nextElementSibling;
      const icon = btn.querySelector('.faq-icon');
      const isOpen = answer.classList.contains('open');

      // Close all
      document.querySelectorAll('.faq-answer').forEach(a => a.classList.remove('open'));
      document.querySelectorAll('.faq-icon').forEach(i => i.textContent = '+');

      // Open clicked (if it was closed)
      if (!isOpen) {
        answer.classList.add('open');
        icon.textContent = '−';
      }
    });
  });

  // ---------- REVIEWS SCROLL ----------
  const reviewsScroll = document.getElementById('reviewsScroll');
  const reviewPrev = document.getElementById('reviewPrev');
  const reviewNext = document.getElementById('reviewNext');

  if (reviewPrev && reviewNext && reviewsScroll) {
    const scrollAmount = 400;

    reviewPrev.addEventListener('click', () => {
      reviewsScroll.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    reviewNext.addEventListener('click', () => {
      reviewsScroll.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  // Countdown timers are self-contained per-section (see maggd-world-cup.liquid and maggd-wc-hero.liquid).

  // ---------- SMOOTH SCROLL FOR ANCHOR LINKS ----------
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const targetId = anchor.getAttribute('href');
      if (targetId === '#') return;
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
